import * as THREE from 'three';
import { Scene, OrthographicCamera, WebGLRenderer, Vector3, MeshBasicMaterial, SphereGeometry, TorusGeometry, Texture } from 'three';
import bgVert from "../glsl/bg.vert";
import bgFrag from "../glsl/bg.frag";
import { text } from 'stream/consumers';

export class RttSceneBase extends THREE.Object3D{

    scene   :Scene;
    camera  :OrthographicCamera;
    renderTarget    :THREE.WebGLRenderTarget;
    material        :THREE.ShaderMaterial;

    sphere: THREE.Mesh;
    speed: THREE.Vector3;
    tgtTexture:Texture;
    //https://www.pentacreation.com/blog/2021/05/210504.html

    constructor(){
        super();
        
        this.scene = new THREE.Scene();
 
        //オフスクリーンレンダリング用のカメラ
        this.camera = new OrthographicCamera();
        
        this.camera.left    =-1;
        this.camera.right   =1;
        this.camera.top     =1;
        this.camera.bottom  =-1;

        this.camera.near = 0.1;
        this.camera.far = 10;
        this.camera.position.set(0,0,1);
        this.camera.lookAt(new Vector3());

        //レンダーターゲットオブジェクト
        this.renderTarget = new THREE.WebGLRenderTarget(
            512*2,
            512*2
        );
        this.renderTarget.texture.minFilter = THREE.LinearFilter;
        this.renderTarget.texture.magFilter = THREE.LinearFilter;
        
    }

    addImpulse(xx:number,yy:number){

    }

    setTexture(texture:THREE.Texture,tex:THREE.Texture){
        
        //console.log(""+tex)

        this.tgtTexture = texture;
        this.material.uniforms.tex1.value = texture;
        this.material.uniforms.flowMap.value = tex;
        

    }

    update(renderer:WebGLRenderer){
        
        //オフスクリーンレンダリング
        renderer.setClearColor(0x000000,1.0);
        renderer.setRenderTarget(this.renderTarget);
        renderer.render(this.scene,this.camera);
        renderer.setRenderTarget(null);
         
        //this.material.uniforms.tex1.value = this.tgtTexture;
        this.material.uniforms.time.value += 0.01;
    }

}